
  import { RequiredConfigVariable } from '@/services/integrations/types';
  import { useIntegrationDetailsStore } from '@/stores/integrationDetails';
  import { Button } from '@/ui/components/Button';
  import { InputField, SwitchField } from '@/ui/components/form';
  import BaseStep, { BaseStepProperties, BASE_STEP_PROPS } from './BaseStep.vue';
  import { computed, defineComponent, ref } from 'vue';

  interface DropdownStepProperties extends BaseStepProperties {
    configVariable: RequiredConfigVariable;
  }

  export default defineComponent<DropdownStepProperties>({
    components: {
      InputField,
      SwitchField,
      Button,
      BaseStep,
    },
    props: [...BASE_STEP_PROPS, 'configVariable'],

    setup(props) {
      const { key } = props.configVariable;
      const store = useIntegrationDetailsStore();
      const host = props.configVariable.connection.inputs.nodes.find(input => input.key === 'host');
      const port = props.configVariable.connection.inputs.nodes.find(input => input.key === 'port');
      const requireSSL = props.configVariable.connection.inputs.nodes.find(input => input.key === 'requireSSL');

      if (!host || !port) {
        throw new Error('Host and port inputs not found');
      }

      const values = {
        host: ref(store.getConnectionConfigVariable(key, 'host')),
        port: ref(store.getConnectionConfigVariable(key, 'port')),
        requireSSL: ref<boolean>(store.getConnectionConfigVariable(key, 'requireSSL') === 'true'),
      };

      const allFilledUp = computed(() => values.host.value && values.port.value);

      const submit = () => {
        if (!allFilledUp.value) {
          return;
        }

        store.setConnectionConfigVariable(key, 'host', values.host.value!);
        store.setConnectionConfigVariable(key, 'port', values.port.value!);
        if (requireSSL) {
          store.setConnectionConfigVariable(key, 'requireSSL', values.requireSSL.value ? 'true' : 'false');
        }
        store.nextStep();
      };

      return {
        host,
        port,
        requireSSL,
        values,
        submit,
        allFilledUp,
      };
    },
  });
